const Label = ({ children }) => (
  <label className="block mb-1 text-sm font-medium text-gray-700">
    {children}
  </label>
);

export default Label;
